import { render } from "./RxExamination.vue?vue&type=template&id=64fb511c&scoped=true"
import script from "./RxExamination.vue?vue&type=script&lang=js"
export * from "./RxExamination.vue?vue&type=script&lang=js"

import "./RxExamination.vue?vue&type=style&index=0&id=64fb511c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fb511c"]])

export default __exports__